import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';
import { MultiSelect } from 'components';
import { accessPermissions } from 'utils';
import { useTranslation } from 'react-i18next';
import { TEAM } from 'actions';

export const AccessPermission = ({ title, selectedMem, setSelectedMem = () => {}, register = () => {}, errors = [], isEditTask, eventTask, onRemove = () => {}}) => {
    const { t } = useTranslation();

    const handleAddPermission = (value, memIndex) => {
        const newSelectedMember = [...selectedMem];
        newSelectedMember[memIndex].permissions.push(value[0]);
        setSelectedMem(newSelectedMember)
    }

    const handleRemovePermission = (value, memIndex) => {
        const newSelectedMember = [...selectedMem];
        newSelectedMember[memIndex].permissions = newSelectedMember[memIndex].permissions.filter(permission => permission.id !== value.id)
        setSelectedMem(newSelectedMember)
    }

    return(
        <div className="tr__access-permission">
            {title && (
                <h4 className="h4 f-medium">{title}</h4>
            )}
            <div className="list">
                {selectedMem && selectedMem.length > 0 ? selectedMem.map((mem, memIndex) => {
                        return (
                            <div className="tr__role d-flex align-items-center justify-content-between col-12" key={mem?.id}>
                                <div className="col-7 d-flex align-items-center">
                                    <i className="remove-btn icon-times" 
                                        onClick={() => onRemove(mem)} 
                                    />
                                    {mem?.type === TEAM.toUpperCase() ? <i className="icon-users mrx2"></i> : <img className="mrx2" src={mem?.icon} alt={mem?.title} /> }
                                    <div className="d-flex align-items-center member__name">
                                        <h6 className="f-medium h6 name">{!mem?.title ? mem?.description : mem?.title}</h6>
                                        {eventTask?.creator?.id === mem.id && <span className="text-error f-medium mlx4">(Creator)</span> }
                                    </div>
                                </div>
                                <MultiSelect
                                    mode="inline"
                                    className="col-5 mbx4"
                                    name={`permission-group`}
                                    options={accessPermissions.map(item => {
                                        return {
                                            id: item.key,
                                            title: t(item.value),
                                        }
                                    })}
                                    value={selectedMem[memIndex]?.permissions}
                                    label={t('')}
                                    onChange={items => handleAddPermission(items, memIndex)}
                                    handleRemoveOption={item => handleRemovePermission(item, memIndex)}
                                    multiple={true}
                                />
                            </div>
                        )
                    }) : ''
                }
            </div>
        </div>
    )
};

AccessPermission.propTypes = {
    title: PropTypes.string,
}